import React, { createContext, useContext } from "react"

import { ProjectPermissions } from "entities/projects/types/ProjectPermissions"
import { ProductPositionFormOptions } from "features/product-position-management/types/ProductPositionFormOptions"

export interface ProductPositionFormCoreContextValue {
  id: string
  isReadonly: boolean
  isDisabled?: boolean
  formOptions?: ProductPositionFormOptions
  permissions: ProjectPermissions
  onSubmit: () => void
  onCancel: () => void
  onEdit?: () => void
}

const ProductPositionFormCoreContext = createContext<
  ProductPositionFormCoreContextValue | undefined
>(undefined)

export interface ProductPositionFormCoreProviderProps {
  value: ProductPositionFormCoreContextValue
  children: React.ReactNode
}

export const ProductPositionFormCoreProvider = React.memo(
  ({ value, children }: ProductPositionFormCoreProviderProps) => (
    <ProductPositionFormCoreContext.Provider value={value}>
      {children}
    </ProductPositionFormCoreContext.Provider>
  )
)

export function useProductPositionFormCoreContext(): ProductPositionFormCoreContextValue {
  const context = useContext(ProductPositionFormCoreContext)
  if (!context) {
    throw new Error(
      "useProductPositionFormCoreContext must be used within a ProductPositionFormCoreProvider"
    )
  }
  return context
}
